<div
  [class.show]="isVisible"
  [ngClass]="openLeftPanel ? 'openLeftPanelClass' : 'closedLeftPanelClass'"
  draggable="false"
  id="legend-wrapper">
  <button id="legend" class="handle" draggable="false" (click)="isVisible = !isVisible">
    <span class="vtext">Tegnforklaring</span>
  </button>
  <div class="card">
    @for (legend of legendArray; track legend) {
      <div>
        @if (legend.header) {
          <div class="header">{{ legend.name }}</div>
        }
        @if (legend.type === 'Image') {
          <img alt="Tegnforklaring for kartlag: {{ legend.header }}" draggable="false" src="{{ legend.url }}" />
        }
      </div>
    }
  </div>
</div>
